<template>
	<section class="kr-placard-layout">
		<div class="layout-column layout-column--left">
			<header>
				<slot name="header"></slot>
			</header>
			<footer>
				<slot name="mid"></slot>
			</footer>
		</div>
		<div class="layout-column layout-column--right">
			<div class="layout-stack confidence-stack">
				<slot name="confidence"></slot>
			</div>
			<div class="layout-stack progress-stack">
				<slot name="progress"></slot>
			</div>
			<div class="layout-stack current-value-stack">
				<slot name="current-value"></slot>
			</div>
			<div class="layout-stack target-value-stack">
				<slot name="target-value"></slot>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "KRPlacardLayout",
};
</script>

<style lang="scss" scoped>
$krPlacardLayoutBorderColor: $color1-200;

.kr-placard-layout {
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	align-items: flex-start;
	gap: 2rem;

	border: 0.0625rem solid $krPlacardLayoutBorderColor;
	border-radius: 0.5rem;
	box-shadow: 0 0.0625rem .25rem rgba(42, 47, 69, 0.1);

	padding: 1rem;
	text-align: left;

	@include for-size('md') {
		flex-direction: row;
	}
}

.kr-placard-layout .layout-column {
	flex: 1;
	display: flex;
}

.kr-placard-layout .layout-column--left {
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 0.5rem;

	header, footer {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		gap: 0.5rem;
	}

	footer {
		align-items: center;
	}
}

.kr-placard-layout .layout-column--right {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 2rem;
}

.kr-placard-layout .layout-stack {
	flex: 1;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 0.4rem;

	&.progress-stack {
		flex: 5;
	}

	> div {
		width: 50%;
	}
}
</style>
